<template>
  <div id="monitor">
    <screen-adapter>
      <div class="monitor-platform">
        <div class="monitor-header">
          <span class="title">{{ screenName }}</span>
          <div class="fullscreen">
            <span class="action action-fullscreen">
              <fullscreen :id="id" />
            </span>
          </div>
          <div class="socket-time">
            <span>{{ nowTime }}</span>
          </div>
          <!-- <div class="select-refresh-time">
            <div class="icon-refresh" @click="handleShowSelect">
              <i class="el-icon-refresh"></i>
            </div>
            <div class="button-groups">
              <el-button
                v-show="isShowSelect"
                class="select-time-button"
                circle
                v-for="(item, index) in refreshTimeList"
                :key="index"
                @click="handleShowTime"
                >{{ item }}</el-button
              >
            </div>
            <div class="time-select">
              {{ `${Math.round(refreshTime / 1000)}s` }}
            </div>
          </div> -->
        </div>
        <div class="view-container">
          <div class="container-top">
            <current-number-resource
            :data="basicResourceData"
            :title="basicTitle"
            :isRefresh="isRefresh"
            />
            <socket-amount
              :data="healthData"
              :totalCount="resourceCountData.resourceCount"
              :isRefresh="isRefresh"
              @handleFinishRefresh="handleFinishRefresh"
            />
            <current-number-resource
            :data="serviceResourceData"
            :title="serviceTitle"
            :isRefresh="isRefresh"
            />
          </div>
          <div class="container-middle">
            <div
              class="container-situation-resource"
              v-for="(item,index) in sourceStuationList"
              :key="index"
            >
              <card-situation-resource
               :data="item.situationData"
              :title="item.title"
              :isRefresh="isRefresh"
              />
            </div>
          </div>
          <div class="container-bottom">
            <interface-request-overview
             :tendencyData="tendencyData"
             :isRefresh="isRefresh"
             />
            <current-request-top
             :title="requestTopTitle"
              :data="requestTopData"
             :isRefresh="isRefresh"
               />
            <current-request-top
             :title="errorTopTitle"
              :data="errorTopData"
             :isRefresh="isRefresh"
               />
          </div>
        </div>
      </div>
    </screen-adapter>
  </div>
</template>
<script>
import Moment from 'moment';
import ScreenAdapter from '@/components/screen-adapter/index.vue';
import Fullscreen from '@/components/fullscreen/index.vue';
import screenfull from 'screenfull/dist/screenfull';
import { Message } from 'element-ui';
import { showTimes } from '@/utils/index';
import {
  queryHealthData,
  queryApiTendency,
  queryApiRequestCountTop,
  queryApiErrorCountTop,
  queryResourceCount,
  queryEcsSummary,
  queryK8sSummary,
  queryRdsSummary,
  queryRedisSummary,
  queryEsSummary,
  querySlbSummary,
} from '@/api/monitor';
import CurrentNumberResource from './components/current-number-resource.vue';
import SocketAmount from './components/socket-amount.vue';
import CardSituationResource from './components/card-situation-resource.vue';
import InterfaceRequestOverview from './components/interface-request-overview.vue';
import CurrentRequestTop from './components/current-request-top.vue';

export default {
  components: {
    ScreenAdapter,
    Fullscreen,
    CurrentNumberResource,
    SocketAmount,
    CardSituationResource,
    InterfaceRequestOverview,
    CurrentRequestTop,
  },
  data() {
    return {
      isRefresh: false,
      screenName: '百布技术监控平台',
      refreshTimeList: [15, 30, 60], // 刷新频率选择
      requestTopTitle: '接口请求排行',
      errorTopTitle: '接口错误排行',
      analyzeTimeFrom: `${new Moment().format('YYYY-MM-DD')} 00:00:00`,
      analyzeTimeTo: `${new Moment().format('YYYY-MM-DD')} 23:59:59`,
      // 屏幕尺寸
      screenWidth: document.documentElement.clientWidth,
      screenHeight: document.documentElement.clientHeight,
      nowTime: '',
      id: 'monitor', // 指定全屏内容的id
      basicTitle: '基础资源',
      serviceTitle: '服务资源',
      // 频率刷新定时器
      wsInstance: {
        ws1: null,
        ws2: null,
        ws3: null,
        ws4: null,
        ws5: null,
        ws6: null,
        ws7: null,
        ws8: null,
        ws9: null,
        ws10: null,
        ws11: null,
      },
      // 趋势
      tendencyData: {},
      // 接口请求排行
      requestTopData: [],
      // 接口错误排行
      errorTopData: [],
      // 健康数据
      healthData: [
        // {
        //   name: 'PV',
        //   // number: 0,
        // },
        // {
        //   name: 'UV',
        //   // number: 0,
        // },
        // {
        //   name: '接口请求数',
        //   // number: 0,
        // },
        // {
        //   name: '接口错误数',
        //   // number: 0,
        // },
        // {
        //   name: '接口错误率',
        //   // number: `${0}%`,
        //   // number: 0,
        // },
      ],
      // 资源数量
      resourceCountData: {},
      // 云主机概况
      ecsData: {},
      k8sData: {},
      rdsData: {},
      redisData: {},
      esData: {},
      slbData: {},
      // 控制展示选择刷新频率
      isShowSelect: false,
      isShowRefreshTime: false,
      refreshTime: 30000,
    };
  },
  created() {
    this.handleResize();
    this.getNowTime();
    const autoGetPromise = [];
    for (let i = 1; i < 12; i++) {
      autoGetPromise.push(this.autoGetSocketData(i));
    }
    Promise.all(autoGetPromise)
      .then(() => {
        // this.isRefresh = true;
      })
      .catch(() => {
        Message.error('请求失败');
      });
    window.addEventListener('online', () => {
      // 轮询
      for (let i = 1; i < 12; i++) {
        autoGetPromise.push(this.autoGetSocketData(i));
      }
    });
    window.addEventListener('offline', () => {
      Message.error('网络连接已断开');
      // console.log('offline');
      this.destroyedSocket();
    });
  },
  beforeDestroy() {
    // 断开
    this.destroyedSocket();
  },
  watch: {
    refreshTime() {
      const autoGetPromise = [];
      for (let i = 1; i < 12; i++) {
        autoGetPromise.push(this.autoGetSocketData(i));
      }
      Promise.all(autoGetPromise).catch(() => {
        Message.error('请求失败');
      });
    },
  },
  computed: {
    // 基础资源
    basicResourceData() {
      return [
        {
          name: '云主机数',
          number: this.resourceCountData.ecsCount,
        },
        {
          name: 'k8s集群数',
          number: this.resourceCountData.k8sClusterCount,
        },
        {
          name: 'k8s节点数',
          number: this.resourceCountData.k8sNodeCount,
        },
        {
          name: 'rds实例数',
          number: this.resourceCountData.rdsCount,
        },
        {
          name: 'rds慢查询率',
          number: this.resourceCountData.rdsSlowQueryRate,
        },
        {
          name: 'redis实例数',
          number: this.resourceCountData.redisCount,
        },
        {
          name: 'redis key数',
          number: this.resourceCountData.redisKeyCount,
        },
        {
          name: 'es实例数',
          number: this.resourceCountData.esCount,
        },
        {
          name: 'slb数',
          number: this.resourceCountData.slbCount,
        },
      ];
    },
    // 服务资源
    serviceResourceData() {
      return [
        {
          name: 'jenkins工程数',
          number: this.resourceCountData.projectCount,
        },
        {
          name: '前端工程数',
          number: this.resourceCountData.frontendProjectCount,
        },
        {
          name: '后端工程数',
          number: this.resourceCountData.backendProjectCount,
        },
        {
          name: 'namespace数',
          number: this.resourceCountData.namespaceCount,
        },
        {
          name: 'deployment数',
          number: this.resourceCountData.deploymentCount,
        },
        {
          name: 'pod数',
          number: this.resourceCountData.podCount,
        },
      ];
    },
    // 资源概况数组
    sourceStuationList() {
      return [
        {
          title: '云主机概况',
          situationData: {
            subTitle: ['CPU使用率', '内存使用率', '硬盘使用率'],
            cpuUsedRate: this.ecsData.cpuUsedRate,
            memoryUsedRate: this.ecsData.memoryUsedRate,
            diskUsedRate: this.ecsData.diskUsedRate,
          },
        },
        {
          title: 'k8s概况',
          situationData: {
            subTitle: ['CPU使用率', '内存使用率', '硬盘使用率'],
            cpuUsedRate: this.k8sData.cpuUsedRate,
            memoryUsedRate: this.k8sData.memoryUsedRate,
            diskUsedRate: this.k8sData.diskUsedRate,
          },
        },
        {
          title: 'rds概况',
          situationData: {
            subTitle: ['CPU使用率', '内存使用率', '硬盘使用率'],
            cpuUsedRate: this.rdsData.cpuUsedRate,
            memoryUsedRate: this.rdsData.memoryUsedRate,
            diskUsedRate: this.rdsData.diskUsedRate,
          },
        },
        {
          title: 'redis概况',
          situationData: {
            subTitle: ['CPU使用率', '内存使用率', '响应时间(ms)'],
            cpuUsedRate: this.redisData.cpuUsedRate,
            memoryUsedRate: this.redisData.memoryUsedRate,
            returnTime: this.redisData.returnTime,
          },
        },
        {
          title: 'es概况',
          situationData: {
            subTitle: ['CPU使用率', '内存使用率', '硬盘使用率'],
            cpuUsedRate: this.esData.cpuUsedRate,
            memoryUsedRate: this.esData.memoryUsedRate,
            diskUsedRate: this.esData.diskUsedRate,
          },
        },
        {
          title: 'slb概况',
          situationData: {
            subTitle: ['qps', '响应时间(ms)', 'upstream响应时间(ms)'],
            qps: this.slbData.qps,
            returnTime: this.slbData.returnTime,
            upstreamReturnTime: this.slbData.upstreamReturnTime,
          },
        },
      ];
    },
  },
  methods: {
    handleFinishRefresh() {
      setTimeout(() => {
        this.isRefresh = false;
      }, 0);
    },
    // 展示刷新频率时间选择按钮
    handleShowSelect() {
      if (!this.isShowSelect) {
        this.isShowSelect = true;
      } else {
        this.isShowSelect = false;
      }
    },
    // 展示已选时间
    handleShowTime(event) {
      this.destroyedSocket();
      this.isShowRefreshTime = true;
      this.refreshTime = event.target.innerHTML * 1000;
      this.isShowSelect = false;
    },
    // 切换刷新频率icon
    handleChangeIcon() {
      if (this.isChangeIcon) {
        this.isChangeIcon = false;
        return;
      }
      this.isChangeIcon = true;
    },
    // 清除定时器
    destroyedSocket() {
      clearInterval(this.wsInstance.ws1);
      clearInterval(this.wsInstance.ws2);
      clearInterval(this.wsInstance.ws3);
      clearInterval(this.wsInstance.ws4);
      clearInterval(this.wsInstance.ws5);
      clearInterval(this.wsInstance.ws6);
      clearInterval(this.wsInstance.ws7);
      clearInterval(this.wsInstance.ws8);
      clearInterval(this.wsInstance.ws9);
      clearInterval(this.wsInstance.ws10);
      clearInterval(this.wsInstance.ws11);
    },
    // 监听全屏放大尺寸resize
    handleResize() {
      screenfull.on('change', (event) => {
        setTimeout(() => {
          this.screenWidth = String(event.target.clientWidth);
          this.screenHeight = String(event.target.clientHeight);
        }, 300);
      });
    },
    // 获取当前时间
    getNowTime() {
      setInterval(() => {
        this.nowTime = showTimes();
      }, 1000);
    },
    // 接口请求
    autoGetSocketData(key) {
      if (this.wsInstance[`ws${key}`]) {
        clearInterval(this.wsInstance[`ws${key}`]);
      }
      const params = {
        analyzeTimeFrom: this.analyzeTimeFrom,
        analyzeTimeTo: this.analyzeTimeTo,
      };
      const apiList = {
        1: async () => {
          const { data } = await queryApiRequestCountTop(params);
          this.requestTopData = data;
        },
        2: async () => {
          const { data } = await queryApiErrorCountTop(params);
          this.errorTopData = data;
        },
        3: async () => {
          const { data } = await queryApiTendency(params);
          this.tendencyData = data;
        },
        4: async () => {
          const { data } = await queryHealthData(params);
          // 格式化健康数据
          this.healthData = [];
          Object.keys(data).forEach((item) => {
            if (item === 'pv') {
              this.healthData.push({ name: 'PV', number: data[item] });
            } else if (item === 'uv') {
              this.healthData.push({ name: 'UV', number: data[item] });
            } else if (item === 'apiRequest') {
              this.healthData.push({ name: '接口请求数', number: data[item] });
            } else if (item === 'apiError') {
              this.healthData.push({ name: '接口错误数', number: data[item] });
            } else {
              this.healthData.push({ name: '接口错误率', number: data[item] });
            }
          });
          // this.healthData = data;
        },
        5: async () => {
          const { data } = await queryResourceCount(params);
          this.resourceCountData = data;
        },
        6: async () => {
          const { data } = await queryEcsSummary(params);
          this.ecsData = data;
        },
        7: async () => {
          const { data } = await queryK8sSummary(params);
          this.k8sData = data;
        },
        8: async () => {
          const { data } = await queryRdsSummary(params);
          this.rdsData = data;
        },
        9: async () => {
          const { data } = await queryRedisSummary(params);
          this.redisData = data;
        },
        10: async () => {
          const { data } = await queryEsSummary(params);
          this.esData = data;
        },
        11: async () => {
          const { data } = await querySlbSummary(params);
          this.slbData = data;
        },
      };
      apiList[key]();

      this.wsInstance[`ws${key}`] = setInterval(() => {
        apiList[key]();
        if (key === 1) {
          this.isRefresh = true;
        }
      }, this.refreshTime);
    },
  },
};
</script>
<style lang="scss" scoped>
.monitor-platform {
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-color: #000;
  background-image: url("../../assets/screen-adapter/background.png");
  width: 100%;
  height: 100%;
  .monitor-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    font-family: SourceHanSansCN-Mediu;
    text-align: center;
    font-weight: 500;
    color: #fff;
    height: 6%;
    min-height: 60px;
    width: 100%;
    background-image: url("../../assets/screen-adapter/top-header.png");
    background-size: cover;
  }
  .title {
    text-shadow: 0px 0px 10px #00f9ff;
  }
  .fullscreen {
    cursor: pointer;
    position: absolute;
    right: 1.25%;
    top: 35.65%;
    font-size: 30px;
    color: #3df3f3;
  }
  .socket-time {
    font-size: 16px;
    position: absolute;
    left: 77.5%;
    bottom: -20%;
    color: #70a0ff;
  }
  .select-refresh-time {
    cursor: pointer;
    position: absolute;
    right: 9%;
    top: 60%;
    display: flex;
    align-items: center;
    .icon-refresh {
      width: 30px;
      height: 30px;
      padding: 5px;
      color: #3df3f3;
      float: left;
      font-size: 24px;
    }
    .button-groups {
      position: absolute;
      right: -120%;
      top: 140%;
      display: flex;
      .select-time-button {
        padding: 6px;
        font-size: 12px;
        color: #3df3f3;
        background: transparent;
        // background-image: url("../../assets/screen-adapter/card-bg.png");
        // background-size: 100% 100%;
        // background-repeat: no-repeat;
      }
    }
    .time-select {
      font-size: 14px;
      position: absolute;
      right: -80%;
      top: 30%;
      color: #1acfd7;
    }
  }
}
.view-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 91.85%;
  box-sizing: border-box;
  padding: 11px 18px 29px;
  .container-top {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }
  .container-middle {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .container-situation-resource {
      flex: 1;
    }
  }
  .container-bottom {
    display: flex;
    justify-content: space-between;
  }
}
</style>
